




















































import { Vue } from 'vue-property-decorator'
import '../../styles/view-tile.css'
import { Alerts } from '../../dataLayer/Alerts'
import IAlert from '../../viewModel/IAlert'
import RemoveItemModal from '../general/RemoveItemModal.vue'
import OkModal from '../general/OkModal.vue'
import moment from 'moment'

interface IData {
  removeItem: IAlert
  showRemoveModal: boolean
  showRemoveErrorModal: boolean
  alerts: IAlert[]
  isAdmin: boolean
  loading: boolean
  headers: { text: string; value: string }[]
}

export default Vue.extend({
  components: { RemoveItemModal, OkModal },
  name: 'AdminAlertList',
  data: function (): IData {
    return {
      removeItem: {} as IAlert,
      showRemoveModal: false,
      showRemoveErrorModal: false,
      alerts: [] as IAlert[],
      isAdmin: false,
      loading: true,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Title', value: 'title' },
        { text: 'Tags', value: 'tags' },
        { text: 'Event Start Date', value: 'startDate' },
        { text: 'Event End Date', value: 'endDate' },
        { text: 'Start Displaying On', value: 'startDisplayingOn' },
        { text: 'Stop Displaying On', value: 'stopDisplayingOn' },
        { text: 'Actions', value: 'actions' },
      ],
    }
  },
  mounted: async function (): Promise<void> {
    await this.loadData()
    this.$root.$on('alerts-modified', () => {
      this.loadData()
    })
  },
  props: {
    tags: {
      type: Array,
      required: true,
    },
    alertTags: {
      type: Array,
      required: true,
    },
  },
  filters: {
    formatDate(date) {
      return moment(date).format('yyyy-MM-DD')
    },
    convertToTags(item) {
      return item.tags
        .map((x) => item.tagItems.find((y) => y.id === x).name)
        .join(', ')
    },
  },
  watch: {
    tags: async function () {
      await this.loadData()
    },
  },
  methods: {
    loadData: async function () {
      this.loading = true
      const viewModel = await Alerts.loadAlerts(
        this.tags as number[],
        false,
        false
      )
      this.alerts = viewModel.alerts
      for (const alert of this.alerts) {
        alert.tagItems = this.alertTags
      }
      this.isAdmin = viewModel.isAdmin
      this.loading = false
    },
    deleteItem(alert: IAlert) {
      this.removeItem = alert
      this.showRemoveModal = true
    },
    editItem(alert) {
      this.$emit('onEdit', alert)
    },
    deleteAlert: async function () {
      const result = await fetch(`/api/Alerts/${this.removeItem.id}`, {
        method: 'DELETE',
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
      if (result.ok) {
        this.alerts = this.alerts.filter(
          (alert: IAlert) => alert.id !== this.removeItem.id
        )
        this.removeItem = {} as IAlert
      } else {
        this.showRemoveErrorModal = true
      }
      this.showRemoveModal = false
    },
    closeRemoveModal() {
      this.showRemoveModal = false
      this.removeItem = {} as IAlert
    },
    closeOkModal() {
      this.removeItem = {} as IAlert
      this.showRemoveErrorModal = false
    },
  },
})
